import React from 'react'
import { Container } from 'react-bootstrap'
import {AbrasiveData, ExtraData, ExtraData_2, ExtraData_3} from './../SliderData.js';
import MainStatements from './../components/MainStatements';
import {FeaturedData} from './../featured_data';
import { Link } from 'react-router-dom';

const HomeScreen = () => {
    return (
        <Container>
            {/* Header Image */}
            <div className="grid relative">
                <img id="head_image" src="/images/home_images/grinding_image.jpg" alt="home_image" className="justify-self-center"/>
                <div className="centering text-center graying" id="head_title">
                    <h1 className="text-4xl anton text-white pt-3 pb-2">TMK Inc.</h1>
                    <h2 className="text-2xl anton text-white py-2">Anything About Grinding, TMK is With You!</h2>
                    <h3 className="text-xl anton text-white pt-2 pb-3 px-2">Complete processes quickly and safely with TMK Abrasives, backed by our quality solutions.</h3>
                </div>
            </div>
            {/* Feature Products */}
            <div className="pt-4">
                <h2 className="text-2xl anton text-gray-700 pt-3 pb-2">Featured Products</h2>
                <div className="grid grid-cols-4 pb-3">
                    {FeaturedData.map((featured_product) => (
                        <div className="flex flex-col px-2 featured_products self-end">
                            <Link to={`/products/${featured_product.brand_url}/${featured_product.product_url}`}>
                                <img src={featured_product.image} alt="featured_product" className="object-cover"/>
                            </Link>
                            <Link to={`/products/${featured_product.brand_url}/${featured_product.product_url}`}>
                                <h2 className="text-center anton text-xl pb-2">{featured_product.product_name}</h2>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
            <div className="border-b border-gray-400"></div>
            {/* first slide */}
            <div className="grid xl:grid-cols-3 lg:grid-cols-1 md:grid-cols-1 sm:grid-cols-1 w-full pt-5">
                <MainStatements data={AbrasiveData} h2="Have the Best Product Experience With TMK" h3="더 나은, 더 앞선 기술 TMK" h4="고품질 프리미엄 제품만을 선정, 공급하며 세계최고 정밀도의 제품을 생산하기 위해 노력하고 있습니다."/>
            </div>
            {/* second slide */}
            <div className="grid xl:grid-cols-3 lg:grid-cols-1 md:grid-cols-1 sm:grid-cols-1 w-full lg:py-5">
                <MainStatements data={ExtraData} h2="QUALITY SOLUTIONS, CONTINUOUS INNOVATION" h3="뛰어난 내구성 및 정밀도" h4="허트라인(Hirt-Line)사와 이노그라인드(Innogrind)사와 함께 보다 나은 연마작업."/>
            </div>
            {/* third slide */}
            <div className="grid xl:grid-cols-3 lg:grid-cols-1 md:grid-cols-1 sm:grid-cols-1 w-full pb-5">
                <MainStatements data={ExtraData_2} h2="QUALITY SOLUTIONS" h3="더 나은, 더 앞선 기술 TMK" h4="고품질 프리미엄 제품만을 선정, 공급하며 세계최고 정밀도의 제품을 생산하기 위해 노력하고 있습니다."/>
            </div>
            {/* second head image */}
            <div className="grid relative">
                <img id="head_image" src="/images/home_images/doctor_blade.jpg" alt="home_image" className="justify-self-center"/>
                <div className="centering text-center graying" id="head_title">
                    <h1 className="text-4xl anton text-white pt-3 pb-2">TMK Inc.</h1>
                    <h2 className="text-2xl anton text-white py-2">Specialised In Providing High Quality Printing Doctor Blades.</h2>
                    <h3 className="text-xl anton text-white pt-2 pb-3 px-2">Expertise supported by mechanical & chemical engineers</h3>
                </div>
            </div>
            {/* fourth slide  */}
            <div className="grid xl:grid-cols-3 lg:grid-cols-1 md:grid-cols-1 sm:grid-cols-1 w-full pt-5 pb-5">
                <MainStatements data={ExtraData_3} h2="QUALITY SOLUTIONS" h3="더 나은, 더 앞선 기술 TMK" h4="고품질 프리미엄 제품만을 선정, 공급하며 세계최고 정밀도의 제품을 생산하기 위해 노력하고 있습니다."/>
            </div>
        </Container>
    )
}

export default HomeScreen
